var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoThanawi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 50,
    viewBox: "0 0 126 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 50,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Thanavi Landing Page",
    clipPath: "url(#clip0_1_3716)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5870,
    transform: "translate(-60 -30)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "01. Navbar",
    filter: "url(#filter0_d_1_3716)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_3716",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-60 -30H1380V70H-60V-30Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-60 -30H1380V70H-60V-30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo_Thanawi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M95.6908 29.7927L85.5874 39.7241L95.6908 49.6555L105.794 39.7241L95.6908 29.7927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M105.794 0L85.5874 19.8622L95.689 29.7919L105.794 19.8622L115.895 29.7919L126 19.8622L105.794 0Z",
    fill: "#007167"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.8062 31.7202L22.3099 33.5143L24.2047 31.9676L22.6979 30.1736L20.8062 31.7202Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.2051 31.7202L25.7331 33.5143L27.6036 31.9676L26.0969 30.1736L24.2051 31.7202Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.6425 22.8245C30.8094 22.1971 29.8909 21.6876 28.914 21.3106C28.2246 21.037 27.5728 20.6796 26.9737 20.2468C26.8082 20.1163 26.675 19.9506 26.5841 19.7622C26.4932 19.5738 26.4471 19.3675 26.4492 19.159C26.4447 18.9712 26.4599 18.7835 26.4947 18.5988C27.2583 18.3845 28.0503 18.284 28.8443 18.3008C29.8612 18.3202 30.8724 18.4552 31.8578 18.7031L31.9699 18.6345L31.9942 16.4829C31.0531 16.2085 30.0775 16.065 29.0959 16.0568C27.7443 16.0302 26.4076 16.3387 25.2092 16.9538C24.7591 17.7506 24.5155 18.6441 24.4998 19.5554C24.4854 19.913 24.5493 20.2695 24.6874 20.6006C24.8255 20.9318 25.0345 21.2298 25.3002 21.4745C26.0302 22.0851 26.8474 22.5871 27.7256 22.9646C28.5064 23.303 29.2552 23.7089 29.963 24.1775C30.4177 24.5053 30.6481 24.8271 30.6481 25.14L30.6239 25.4559C28.9362 26.0818 26.8524 26.3957 24.3725 26.3976C20.405 26.3976 18.4354 25.0218 18.4637 22.2702C18.4771 21.3235 18.6074 20.3818 18.8518 19.466L18.7366 19.3557L17.0722 19.6537C16.7092 20.7098 16.5238 21.8171 16.5234 22.9318C16.5234 24.6662 17.1298 26.0569 18.3425 27.1039C19.5551 28.1509 21.3994 28.6704 23.8753 28.6625C26.9777 28.6625 29.7376 28.0943 32.1549 26.9579C32.4209 26.2466 32.5604 25.4956 32.5672 24.7377C32.5748 24.3708 32.4968 24.007 32.3391 23.6743C32.1815 23.3416 31.9483 23.0489 31.6577 22.8186",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M63.0379 24.3172L44.5779 24.338C44.5495 23.4738 44.4347 22.6144 44.2353 21.7722C44.0493 20.9732 43.7695 20.1981 43.4016 19.4626C43.0799 18.7952 42.6033 18.2113 42.0101 17.758C41.4589 17.3375 40.7796 17.1118 40.0819 17.1173C39.0713 17.1173 38.1133 17.6855 37.2079 18.8219C36.2406 20.1127 35.5778 21.5989 35.2676 23.1728C36.7753 25.1754 39.2007 26.3118 42.5436 26.582C42.3921 27.5754 42.0616 28.2707 41.5523 28.6681C41.043 29.0654 40.3164 29.2641 39.3725 29.2641C38.2381 29.2706 37.1107 29.0892 36.0376 28.7277L35.88 28.8618L36.1073 30.7899C37.0335 31.2254 38.0457 31.4553 39.0724 31.4634C42.2213 31.4634 44.016 29.8482 44.4566 26.6178H65.0722V17.612H63.0197L63.0379 24.3172ZM37.2988 22.4338C37.5217 21.6494 37.9021 20.9168 38.4175 20.2791C38.8884 19.7288 39.3452 19.4527 39.7878 19.4507C40.6367 19.4507 41.3037 19.9215 41.7706 20.8632C42.28 21.949 42.5674 23.1225 42.6164 24.3172C40.191 24.1384 38.4185 23.5106 37.2988 22.4338Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M62.2656 14.0689L63.7693 15.8182L65.6642 14.2715L64.1817 12.5222L62.2656 14.0689Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M79.2846 11.491L77.8475 9.78638L76.0225 11.2883L77.4595 12.9929L79.2846 11.491Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M77.5511 14.4262L76.0898 12.7007L74.2192 14.2473L75.7017 15.9758L77.5511 14.4262Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M79.3759 12.7458L77.5054 14.2717L78.9879 15.9971L80.8372 14.4743L79.3759 12.7458Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M76.9354 24.3173H73.2852H70.8659V9.78638H68.8135V26.606H73.2852H78.9879V17.6121H76.9354V24.3173Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M11.2597 36.7205H6.73339V49.6839H4.52632V36.7205H0V34.7834H11.2597V36.7205Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M18.4475 38.8693C20.8849 38.8693 22.1047 39.9978 22.1067 42.2547V49.681H19.9481V42.6808C19.9481 41.459 19.263 40.8481 17.8926 40.8481C16.8511 40.8698 15.8461 41.2291 15.0338 41.8702V49.681H12.8691V33.7197H15.0338V39.9004C16.0534 39.2458 17.239 38.8845 18.4566 38.8574",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M33.3421 42.7225V46.9572C33.335 47.8302 33.5201 48.6943 33.8848 49.4903L33.7969 49.681H31.7202C31.6132 49.4553 31.526 49.221 31.4594 48.9807C30.5315 49.6522 29.4072 50.0098 28.255 49.9999C27.0847 49.9999 26.1752 49.7277 25.5264 49.1834C25.2005 48.8935 24.9448 48.5357 24.778 48.136C24.6112 47.7364 24.5375 47.3051 24.5623 46.8738C24.5669 46.0336 24.7824 45.2075 25.1899 44.4689C27.1787 44.019 29.2125 43.7901 31.2533 43.7864V43.0414C31.2533 42.2348 31.0653 41.6566 30.6894 41.307C30.3135 40.9573 29.7476 40.7865 28.9917 40.7944C27.7634 40.8233 26.5456 41.024 25.3748 41.3904L25.2233 41.307V39.4951C26.5626 39.1072 27.9502 38.9036 29.3464 38.8901C30.747 38.8901 31.7646 39.1782 32.3993 39.7544C33.0329 40.3265 33.3512 41.3189 33.3512 42.7344M28.6885 48.3638C29.5984 48.338 30.4861 48.0813 31.2654 47.6188V45.1274C29.7856 45.1674 28.31 45.3028 26.8482 45.5328C26.6879 45.8725 26.6061 46.243 26.6087 46.6175C26.6087 47.7797 27.302 48.3618 28.6885 48.3638Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M42.1983 38.8691C44.6399 38.8691 45.8596 39.9976 45.8576 42.2545V49.6809H43.693V42.6807C43.693 41.4429 43.0078 40.8251 41.6375 40.8271C40.5915 40.8448 39.583 41.2127 38.7786 41.8701V49.6809H36.623V39.1671H38.4845L38.6785 39.9777C39.7235 39.2855 40.9477 38.9009 42.2074 38.8691",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M57.0964 42.7225V46.9572C57.0893 47.8301 57.2744 48.6943 57.6391 49.4902L57.5512 49.681H55.4714C55.3668 49.4546 55.2806 49.2204 55.2137 48.9806C54.2858 49.6521 53.1614 50.0097 52.0092 49.9998C50.839 49.9998 49.9295 49.7277 49.2807 49.1833C48.9557 48.8929 48.7008 48.5349 48.5345 48.1353C48.3682 47.7358 48.2948 47.3047 48.3197 46.8737C48.3242 46.0335 48.5398 45.2074 48.9472 44.4688C50.936 44.019 52.9699 43.79 55.0106 43.7864V43.0413C55.0106 42.2347 54.8226 41.6566 54.4467 41.3069C54.0708 40.9573 53.5038 40.7864 52.7459 40.7944C51.5176 40.8233 50.2998 41.024 49.1291 41.3904L48.9775 41.3069V39.4951C50.3134 39.1039 51.6978 38.8963 53.0915 38.8782C54.4922 38.8782 55.5098 39.1662 56.1445 39.7424C56.7781 40.3146 57.0964 41.3069 57.0964 42.7225ZM52.4428 48.3638C53.3527 48.3379 54.2404 48.0813 55.0197 47.6188V45.1274C53.5399 45.1673 52.0643 45.3027 50.6025 45.5327C50.4422 45.8725 50.3604 46.2429 50.363 46.6174C50.363 47.7797 51.0563 48.3618 52.4428 48.3638Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M75.2187 39.1704L72.0142 49.6841H69.0916L66.8391 41.5545L64.5441 49.6841H61.7306L58.6777 39.1704H60.9939L63.2889 47.6189L65.6931 39.1704H68.4004L70.6742 47.6189L73.0753 39.1704H75.2187Z",
    fill: "#1C355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M77.9482 37.5163L76.2808 35.8981L77.9482 34.259L79.5944 35.8981L77.9482 37.5163ZM79.0305 49.669H76.8659V39.1672H79.0305V49.669Z",
    fill: "#1C355E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1380 68.5H-60V71.5H1380V68.5Z",
    fill: "#E2E5EA",
    fillOpacity: 0.5,
    mask: "url(#path-1-inside-1_1_3716)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3716",
    x: -71.9844,
    y: -38.7885,
    width: 1463.97,
    height: 123.969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.19583
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.99219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.964706 0 0 0 0 0.976471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3716"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3716",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5870,
    fill: "white",
    transform: "translate(-60 -30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoThanawi);
export default __webpack_public_path__ + "static/media/logo_Thanawi.5ba051a983b17ac0173b9b6d73c1e77f.svg";
export { ForwardRef as ReactComponent };